/** @format */

import {CheckType} from '../../types';

export const filterChecksByGroup = (
  checks: ReadonlyArray<CheckType>,
  groupSensors: string[],
): CheckType[] => {
  return checks.filter(check => groupSensors.includes(check.sensor.name));
};
